import React from "react";
import "./App.css";
import Header from "./Component/Header/Header";
import Home from "./Component/Home/Home";
import Features from "./Component/Features/Features";
import Portfolio from "./Component/Portfolio/Portfolio";
import Resume from "./Component/Resume/Resume";
import Testimonial from "./Component/Testimonial/Testimonial";
import Blog from "./Component/Blog/Blog";
import Contact from "./Component/Contact/Contact";
import Footer from "./Component/Footer/Footer";
import Skills from "./Component/Skills/Skills";
import Certification from "./Component/Certification/Certification";
// import NotFound from "./Component/NotFound/NotFound";

function App() {
  return (
    <div className="App">
      <Header />
      <Home />
      <Features />
      <Skills />
      <Portfolio />
      <Resume />
      <Certification />
      <Testimonial />
      {/* <Blog /> */}
      <Contact />
      <Footer />
      {/* <NotFound></NotFound> */}
    </div>
  );
}

export default App;
